module.exports = __webpack_public_path__ + "img/Order-now.1a1d12c5.png";